import styled from 'styled-components';
import { MenuBarSelectProps } from '../components/MenuBarSelect';

const StyledMenuBarSelect = styled.div<MenuBarSelectProps>`
  ${({theme, invert, disabled}) => `
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: ${theme.typography.button.fontSize};
    font-weight: ${theme.typography.button.fontWeight};
    line-height: ${theme.typography.button.lineHeight};
    font-family: ${theme.typography.button.fontFamily};
    
    padding: 0 5px;
    cursor: pointer;
    white-space: nowrap;
    text-decoration: none;
    user-select: none;

    color: ${invert 
      ? theme.palette.common.white 
      : theme.palette.gray[800]};

    background: ${theme.palette.transparent};

    ${disabled ? `
      color: ${theme.palette.text.disabled};

      :hover {
        cursor: default;
      }
    ` : ''}

    ${!disabled ? `
      :hover {
        color: ${invert
          ? theme.palette.secondary.main
          : theme.palette.action.hover};
    ` : ''}
  `}
`;

export { StyledMenuBarSelect };